import React from 'react';

const Map = () => {


    const iframeSrc = "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3867.7851044201934!2d79.14341587509865!3d14.20735748623371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTTCsDEyJzI2LjUiTiA3OcKwMDgnNDUuNiJF!5e0!3m2!1sen!2sin!4v1761638433864!5m2!1sen!2sin";
    return (
        <div>
            <div style={{ height: '250px', minwidth: '300px', width:"100%" }}>
                <iframe
                    title="Google Map Location"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    src={iframeSrc}
                ></iframe>
            </div>

        </div>
    );
}

export default Map;
